// import "../cssstyle/Login.css";

// import { MdEmail } from "react-icons/md";
// import { FaLock } from "react-icons/fa";
// import ThemeToggle from "../jsstyle/ThemeToggle";

// import { useNavigate } from "react-router-dom";
// import { useState, useEffect } from "react";

// import LoadingSpin from "../../features/LoadingSpin";
// import "../cssstyle/Popup.css";
// import { loginService } from "../apiservice/loginService";
// import { verifyEmailToken } from "../apiservice/verifyService";
// import {
//   closeWebSocket,
//   useWebSocket,
// } from "../../context/UseWebSocketContext";
// import { mailVerificationService } from "../apiservice/mailVerificationService";
// import { setTokenCookie } from "../../utils/cookieUtils";
// import { resetPasswordService } from "../apiservice/resetPasswordService";
// import { useAuth } from "../../context/auth";
// import { toast } from "react-toastify";

// import { FcGoogle } from "react-icons/fc"; // Google icon
// import { googleLoginService } from "../apiservice/googleLoginService";
// import GoogleLoginButton from "./GoogleLoginButton";

// //**Extra text for make it huminize */

// // The following line is used to
// //  send the notification: sourceMappingU
// // RL=ubx.amos.gTMzFmjYGSoKET2Mm0ew9A--jsi-bun
// // dle.es7b1cb35.js The general use of the above line
// //  is to post a notification with this line achieved by s
// // ending it along through the available ws

// // The following line is used to
// //  send the notification: sourceMappingU
// // RL=ubx.amos.gTMzFmjYGSoKET2Mm0ew9A--jsi-bun
// // dle.es7b1cb35.js The general use of the above line
// //  is to post a notification with this line achieved by s
// // ending it along through the available ws

// // The following line is used to
// //  send the notification: sourceMappingU
// // RL=ubx.amos.gTMzFmjYGSoKET2Mm0ew9A--jsi-bun
// // dle.es7b1cb35.js The general use of the above line
// //  is to post a notification with this line achieved by s
// // ending it along through the available ws

// // The following line is used to
// //  send the notification: sourceMappingU
// // RL=ubx.amos.gTMzFmjYGSoKET2Mm0ew9A--jsi-bun
// // dle.es7b1cb35.js The general use of the above line
// //  is to post a notification with this line achieved by s
// // ending it along through the available ws

// // The following line is used to
// //  send the notification: sourceMappingU
// // RL=ubx.amos.gTMzFmjYGSoKET2Mm0ew9A--jsi-bun
// // dle.es7b1cb35.js The general use of the above line
// //  is to post a notification with this line achieved by s
// // ending it along through the available ws

// // The following line is used to
// //  send the notification: sourceMappingU
// // RL=ubx.amos.gTMzFmjYGSoKET2Mm0ew9A--jsi-bun
// // dle.es7b1cb35.js The general use of the above line
// //  is to post a notification with this line achieved by s
// // ending it along through the available ws
// // The following line is used to
// //  send the notification: sourceMappingU
// // RL=ubx.amos.gTMzFmjYGSoKET2Mm0ew9A--jsi-bun
// // dle.es7b1cb35.js The general use of the above line
// //  is to post a notification with this line achieved by s
// // ending it along through the available ws
// // The following line is used to
// //  send the notification: sourceMappingU
// // RL=ubx.amos.gTMzFmjYGSoKET2Mm0ew9A--jsi-bun
// // dle.es7b1cb35.js The general use of the above line
// //  is to post a notification with this line achieved by s
// // ending it along through the available ws
// // The following line is used to
// //  send the notification: sourceMappingU
// // RL=ubx.amos.gTMzFmjYGSoKET2Mm0ew9A--jsi-bun
// // dle.es7b1cb35.js The general use of the above line
// //  is to post a notification with this line achieved by s
// // ending it along through the available ws

// // The following line is used to
// //  send the notification: sourceMappingU
// // RL=ubx.amos.gTMzFmjYGSoKET2Mm0ew9A--jsi-bun
// // dle.es7b1cb35.js The general use of the above line
// //  is to post a notification with this line achieved by s
// // ending it along through the available ws

// // The following line is used to
// //  send the notification: sourceMappingU
// // RL=ubx.amos.gTMzFmjYGSoKET2Mm0ew9A--jsi-bun
// // dle.es7b1cb35.js The general use of the above line
// //  is to post a notification with this line achieved by s
// // ending it along through the available ws
// // The following line is used to

// //  send the notification: sourceMappingU
// // RL=ubx.amos.gTMzFmjYGSoKET2Mm0ew9A--jsi-bun
// // dle.es7b1cb35.js The general use of the above line
// //  is to post a notification with this line achieved by s
// // ending it along through the available ws

// //  send the notification: sourceMappingU
// // RL=ubx.amos.gTMzFmjYGSoKET2Mm0ew9A--jsi-bun

// //  send the notification: sourceMappingU
// // RL=ubx.amos.gTMzFmjYGSoKET2Mm0ew9A--jsi-bun

// //  send the notification: sourceMappingU
// // RL=ubx.amos.gTMzFmjYGSoKET2Mm0ew9A--jsi-bun

// //  send the notification: sourceMappingU
// // RL=ubx.amos.gTMzFmjYGSoKET2Mm0ew9A--jsi-bun

// //  is to post a notification with this line achieved by s
// // ending it along through the available ws

// //  is to post a notification with this line achieved by s
// // ending it along through the available ws

// //  send the notification: sourceMappingU
// // RL=ubx.amos.gTMzFmjYGSoKET2Mm0ew9A--jsi-bun

// //  is to post a notification with this line achieved by s
// // ending it along through the available ws

// //  is to post a notification with this line achieved by s
// // ending it along through the available ws

// const Login = () => {
//   const navigate = useNavigate();
//   const [loading, setLoading] = useState(false);

//   const [email, setEmail] = useState("");
//   const [passwod, setPassword] = useState("");
//   const [newUserLoadingState, setNewUserLoadingState] = useState(false);
//   const [rememberMe, setRememberMe] = useState(false);
//   const { connectWebSocket, setErrorMessage } = useWebSocket();
//   const {
//     storeLoginToken,
//     getLoginToken,
//     storeLoginMail,
//     getGoogleAuthToken,
//     setSessionKey,
//     generateSessionKey,
//   } = useAuth();
//   const phoneNumber = "8684953093";
//   const message = "Hello";

//   // Token Access

//   const token = getLoginToken() || getGoogleAuthToken();

//   const handleChangeEmail = (e) => {
//     const inputEmail = e.target.value;
//     setEmail(inputEmail);

//     // Store email instantly
//     storeLoginMail(inputEmail);
//   };

//   const isAuthenticated = !!token; // Example check

//   useEffect(() => {
//     if (isAuthenticated) {
//       navigate("/dashboard/home");
//     }
//   }, [isAuthenticated, navigate]);

//   useEffect(() => {
//     const token = new URLSearchParams(window.location.search).get("token");

//     if (token) {
//       const verify = async () => {
//         try {
//           const response = await verifyEmailToken(token);

//           if (response.status === 200) {
//             if (
//               response.data.error === false &&
//               response.data.mail_verification_error === false
//             ) {
//               // console.log("error")

//               toast.success(response?.data?.data);
//               setTimeout(() => {
//                 navigate("/login");
//               }, 3000);
//             }
//           } else {
//             toast.error(response?.data?.data);
//             //    console.log("error1")
//           }
//         } catch (error) {
//           toast.error(error.response?.data?.error);
//           //  console.log("error2")
//         }
//       };

//       verify();
//     }
//   }, []);

//   const validUser = (email = "", passwod = "") => {
//     if (!email || !passwod) {
//       return "Email and password are required";
//     }
//     if (!/^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/g.test(email)) {
//       return "Invalid email format.";
//     }

//     return null;
//   };

//   const handleLogin = async (er) => {
//     er.preventDefault();
//     localStorage.removeItem("session-token");
//     localStorage.removeItem("sec-key");
//     localStorage.removeItem("google-token");

//     //Checking validity
//     try {
//       const dataerror = validUser(email, passwod);

//       if (dataerror) {
//         throw new Error(dataerror);
//       }
//     } catch (error) {
//       toast.error(error.message);
//       return;
//     }

//     setLoading(true);
//     const data = {
//       e: email.trim(),
//       p: passwod,
//     };

//     //Calling the login api

//     try {
//       const response = await loginService(data);

//       if (response.status === 200) {
//         if (response.data.error === true) {
//           toast.error(
//             // response?.data?.data
//             <div className="p-4">
//               <p className="mb-2 text-sm text-gray-800">
//                 {response?.data?.data || "Something went wrong."}
//               </p>
//             </div>,
//           );

//           if (response.data.mail_verification_error === true) {
//             toast.info(
//               <div className=" flex items-center justify-center min-h-[60px] w-full ">
//                 <button
//                   type="button"
//                   className="border border-black text-black px-3 py-1 text-sm rounded hover:bg-blue-500 hover:text-white"
//                   onClick={handleMailVerification}
//                 >
//                   Get New Verification Link
//                 </button>
//               </div>,
//               {
//                 autoClose: 5000,
//               },
//             );
//             setLoading(false);
//           }
//         } else {
//           if (response.data?.mail_verification_error === false) {
//             localStorage.removeItem("session-token");
//             setErrorMessage("");
//             sessionStorage.removeItem("denied");

//             setLoading(true);
//             const token = response?.data.data;

//             setTimeout(async () => {
//               storeLoginToken(token);
//               // console.log("step1")
//               if (token) {
//                 const connected = await connectWebSocket(token);
//                 if (connected) {
//                   // console.log("step2")

//                   navigate("/dashboard/home");
//                 } else {
//                   console.log("error");

//                   navigate("/login");
//                   closeWebSocket();
//                 }
//               } else {
//                 navigate("/login");
//                 closeWebSocket();
//               }

//               // Store cookie only if "remember me" is checked
//               if (rememberMe) {
//                 setTokenCookie(token);
//               }
//             }, 1000);
//           } else {
//             toast.error(response?.data?.data);
//           }
//         }
//       } else {
//         toast.error(response?.data?.data || "Something went wrong");
//       }

//       setLoading(false);
//     } catch (error) {
//       toast.error(error?.response?.data?.data || "Something went wrong");
//     }
//   };

//   const handleLogin1 = async () => {
//     navigate("/dashboard/home");
//   };

//   const handleMailVerification = async (dr) => {
//     dr.preventDefault();

//     try {
//       const response = await mailVerificationService(email);

//       if (response.status === 200) {
//         if (response.data.mail_verification_error === false) {
//           toast.success(response?.data?.data);
//         } else {
//           toast.error(response?.data?.data);
//         }
//       }
//     } catch (error) {
//       toast.error(error?.response?.data?.data || "Try again...");
//     }
//   };

//   //Handle rest password

//   const handleForgotPassword = async (email) => {
//     try {
//       if (!email) {
//         // console.warn("⚠️ Email is required to reset password.");
//         toast.warning(" Email is required to reset password.");
//         return;
//       }

//       const result = await resetPasswordService(email);

//       if (result.success) {
//         toast.success(result?.data?.data);
//       } else {
//         toast.error(result?.data?.data);
//       }
//     } catch (error) {
//       if (error.response) {
//         const status = error.response.status;
//         const message = error.response.data?.message;

//         toast.error(error.result?.data?.data);

//         if (status === 404) {
//           console.warn(" Email not found.");
//         } else if (status === 429) {
//           console.warn(" Too many requests. Please try again later.");
//         } else {
//           console.warn(" Something went wrong:", message || "Server error");
//         }
//       } else {
//         console.error("❗Network error or server unreachable.");
//       }
//     }
//   };

//   const newUserLoading = () => {
//     setNewUserLoadingState(true);
//     setTimeout(() => {
//       navigate("/signup");
//     }, 1000);
//   };

//   // This keeps it

//   return (
//     <div className="w-full">
//       <div className="button-container">
//         <ThemeToggle />
//       </div>

//       <div className="w-full">
//         <div className="wrapper">
//           <form action="" onSubmit={handleLogin}>
//             <h1>Login</h1>
//             <div className=" m-4 ">
//               <GoogleLoginButton handleLogin={handleLogin1}></GoogleLoginButton>

//               <div className="flex items-center w-full my-6">
//                 <div className="flex-grow border-t  border-mytextlight dark:border-mytextdark"></div>
//                 <span className="mx-3 text-mytextlight dark:text-mytextdark">
//                   or
//                 </span>
//                 <div className="flex-grow border-t border-mytextlight dark:border-mytextdark"></div>
//               </div>
//             </div>
//             <div className="input-box">
//               <input
//                 type="text"
//                 placeholder="Email"
//                 value={email}
//                 onChange={handleChangeEmail}
//               ></input>
//               <MdEmail className="icon"></MdEmail>
//             </div>
//             <div className="input-box">
//               <input
//                 type="password"
//                 placeholder="Password"
//                 value={passwod}
//                 onChange={(er) => setPassword(er.target.value)}
//               ></input>
//               <FaLock className="icon"></FaLock>
//             </div>

//             <div className="remember-forgot">
//               <label>
//                 <input
//                   type="checkbox"
//                   checked={rememberMe}
//                   onChange={() => setRememberMe(!rememberMe)}
//                 />
//                 <span className="text-sm">Remember Me</span>
//               </label>

//               <a
//                 href="#"
//                 onClick={(e) => {
//                   e.preventDefault();
//                   handleForgotPassword(email);
//                 }}
//               >
//                 Forgot password?
//               </a>
//             </div>

//             <button type="submit" className="my-button" disabled={loading}>
//               {loading ? (
//                 <div className="spinner-wrapper">
//                   <LoadingSpin />
//                 </div>
//               ) : (
//                 "Login"
//               )}
//             </button>

//             <div className="register-link">
//               <div>
//                 Don't have an account?{" "}
//                 <span
//                   onClick={newUserLoading}
//                   className={`signup-wrapper ${newUserLoadingState ? "loading" : ""}`}
//                 >
//                   <span className="signup-text">Signup</span>
//                   {newUserLoadingState && (
//                     <div className="spinner-overlay">
//                       <LoadingSpin />
//                     </div>
//                   )}
//                 </span>
//               </div>
//             </div>
//           </form>
//         </div>

//         <div className="full-line"></div>

//         <div className="terms-conditions">
//           <p>
//             <a
//               href="https://www.algocontroller.com/terms-condition"
//               target="_blank"
//               rel="noopener noreferrer"
//             >
//               {" "}
//               Terms & Conditions
//             </a>
//             <span> | </span>

//             <a
//               href="https://www.algocontroller.com/privacy-policy"
//               target="_blank"
//               rel="noopener noreferrer"
//             >
//               Privacy Policy
//             </a>
//             <span> | </span>

//             {/* <a href={`https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`} target="_blank"
//                             rel="noopener noreferrer" >support@algocontroller.com</a> */}

//             <a rel="noopener noreferrer">support@algocontroller.com</a>
//           </p>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default Login;




import "../cssstyle/Login.css";

import { MdEmail } from "react-icons/md";
import { FaLock } from "react-icons/fa";
import ThemeToggle from "../jsstyle/ThemeToggle";

import { useNavigate } from "react-router-dom";
import { useState, useEffect } from "react";

import LoadingSpin from "../../features/LoadingSpin";
import "../cssstyle/Popup.css";
import { loginService } from "../apiservice/loginService";
import { verifyEmailToken } from "../apiservice/verifyService";
import {
  closeWebSocket,
  useWebSocket,
} from "../../context/UseWebSocketContext";
import { mailVerificationService } from "../apiservice/mailVerificationService";
import { setTokenCookie } from "../../utils/cookieUtils";
import { resetPasswordService } from "../apiservice/resetPasswordService";
import { useAuth } from "../../context/auth";
import { toast } from "react-toastify";

import GoogleLoginButton from "./GoogleLoginButton";

const Login = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [wsConnecting, setWsConnecting] = useState(false);

  const [email, setEmail] = useState("");
  const [passwod, setPassword] = useState("");
  const [newUserLoadingState, setNewUserLoadingState] = useState(false);
  const [rememberMe, setRememberMe] = useState(false);
  const { connectWebSocket, setErrorMessage } = useWebSocket();
  const {
    storeLoginToken,
    getLoginToken,
    storeLoginMail,
    getGoogleAuthToken,
    storeSecKey,
  } = useAuth();

  const token = getLoginToken() || getGoogleAuthToken();
  const isAuthenticated = !!token;

  // Auto redirect if already logged in
  useEffect(() => {
    if (isAuthenticated && !wsConnecting) {
      navigate("/dashboard/home");
    }
  }, [isAuthenticated, navigate, wsConnecting]);

  // Handle email verification token
  useEffect(() => {
    const token = new URLSearchParams(window.location.search).get("token");

    if (token) {
      const verify = async () => {
        try {
          const response = await verifyEmailToken(token);
          if (response.status === 200) {
            if (
              response.data.error === false &&
              response.data.mail_verification_error === false
            ) {
              toast.success(response?.data?.data);
              setTimeout(() => {
                navigate("/login");
              }, 3000);
            }
          } else {
            toast.error(response?.data?.data);
          }
        } catch (error) {
          toast.error(error.response?.data?.error);
        }
      };
      verify();
    }
  }, []);

  const handleChangeEmail = (e) => {
    const inputEmail = e.target.value;
    setEmail(inputEmail);
    storeLoginMail(inputEmail);
  };

  const validUser = (email = "", passwod = "") => {
    if (!email || !passwod) {
      return "Email and password are required";
    }
    if (!/^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/g.test(email)) {
      return "Invalid email format.";
    }
    return null;
  };

  const handleMailVerification = async (dr) => {
    dr.preventDefault();
    try {
      const response = await mailVerificationService(email);
      if (response.status === 200) {
        if (response.data.mail_verification_error === false) {
          toast.success(response?.data?.data);
        } else {
          toast.error(response?.data?.data);
        }
      }
    } catch (error) {
      toast.error(error?.response?.data?.data || "Try again...");
    }
  };

  const handleForgotPassword = async (email) => {
    try {
      if (!email) {
        toast.warning("Email is required to reset password.");
        return;
      }
      const result = await resetPasswordService(email);
      if (result.success) {
        toast.success(result?.data?.data);
      } else {
        toast.error(result?.data?.data);
      }
    } catch (error) {
      if (error.response) {
        const status = error.response.status;
        if (status === 404) {
          console.warn("Email not found.");
        } else if (status === 429) {
          toast.warning("Too many requests. Please try again later.");
        }
      } else {
        console.error("Network error or server unreachable.");
      }
    }
  };

  const newUserLoading = () => {
    setNewUserLoadingState(true);
    setTimeout(() => {
      navigate("/signup");
    }, 1000);
  };

  // ✅ MAIN LOGIN HANDLER - Errors dikhenge, WebSocket connecting nahi dikhega
  const handleLogin = async (er) => {
    er.preventDefault();
    
    // Clear old data
    localStorage.removeItem("session-token");
    localStorage.removeItem("sec_key");
    localStorage.removeItem("google-token");
    sessionStorage.removeItem("denied");
    setErrorMessage("");

    // Validate input - ✅ Error toast dikhega
    try {
      const dataerror = validUser(email, passwod);
      if (dataerror) {
        toast.error(dataerror);
        return;
      }
    } catch (error) {
      toast.error(error.message);
      return;
    }

    setLoading(true);
    const data = {
      e: email.trim(),
      p: passwod,
    };

    try {
      const response = await loginService(data);

      if (response.status === 200) {
        if (response.data.error === true) {
          // ✅ API error toast dikhega
          toast.error(response?.data?.data);
          if (response.data.mail_verification_error === true) {
            toast.info(
              <div className="flex items-center justify-center min-h-[60px] w-full">
                <button
                  type="button"
                  className="border border-black text-black px-3 py-1 text-sm rounded hover:bg-blue-500 hover:text-white"
                  onClick={handleMailVerification}
                >
                  Get New Verification Link
                </button>
              </div>,
              { autoClose: 5000 }
            );
          }
          setLoading(false);
        } else {
          // Login success - get token
          const loginToken = response?.data?.data;
          
          if (!loginToken) {
            toast.error("No token received");
            setLoading(false);
            return;
          }

          // Store token
          storeLoginToken(loginToken);
          storeLoginMail(email);
          
          // Store security key if present
          if (response?.data?.sec_key) {
            storeSecKey(response.data.sec_key);
            localStorage.setItem("sec_key", response.data.sec_key);
          }

          // ✅ Show connecting state (NO TOAST for connecting)
          setWsConnecting(true);

          // ✅ Connect WebSocket (silent, no toast)
          const connected = await connectWebSocket(loginToken);
          
          if (connected) {
            console.log("✅ WebSocket connected");
            
            // Store cookie if remember me is checked
            if (rememberMe) {
              setTokenCookie(loginToken);
            }
            
            // ✅ Only ONE success toast
            toast.success("Login successful!");
            
            // Navigate to dashboard
            setTimeout(() => {
              setWsConnecting(false);
              navigate("/dashboard/home", { replace: true });
            }, 500);
          } else {
            // ✅ WebSocket failed toast dikhega
            console.error("❌ WebSocket connection failed");
            toast.error("Connection failed. Please try again.");
            closeWebSocket();
            setWsConnecting(false);
            setLoading(false);
          }
        }
      } else {
        // ✅ API error toast dikhega
        toast.error(response?.data?.data || "Something went wrong");
        setLoading(false);
      }
    } catch (error) {
      console.error("Login error:", error);
      // ✅ Network error toast dikhega
      toast.error(error?.response?.data?.data || "Network error. Please try again.");
      setLoading(false);
    }
  };

  // Google login handler
  const handleGoogleLogin = async () => {
    navigate("/dashboard/home");
  };

  return (
    <div className="w-full">
      <div className="button-container">
        <ThemeToggle />
      </div>

      <div className="w-full">
        <div className="wrapper">
          <form onSubmit={handleLogin}>
            <h1>Login</h1>
            <div className="m-4">
              <GoogleLoginButton handleLogin={handleGoogleLogin} />

              <div className="flex items-center w-full my-6">
                <div className="flex-grow border-t border-mytextlight dark:border-mytextdark"></div>
                <span className="mx-3 text-mytextlight dark:text-mytextdark">
                  or
                </span>
                <div className="flex-grow border-t border-mytextlight dark:border-mytextdark"></div>
              </div>
            </div>
            
            <div className="input-box">
              <input
                type="text"
                placeholder="Email"
                value={email}
                onChange={handleChangeEmail}
              />
              <MdEmail className="icon" />
            </div>
            
            <div className="input-box">
              <input
                type="password"
                placeholder="Password"
                value={passwod}
                onChange={(er) => setPassword(er.target.value)}
              />
              <FaLock className="icon" />
            </div>

            <div className="remember-forgot">
              <label>
                <input
                  type="checkbox"
                  checked={rememberMe}
                  onChange={() => setRememberMe(!rememberMe)}
                />
                <span className="text-sm">Remember Me</span>
              </label>
              <a
                href="#"
                onClick={(e) => {
                  e.preventDefault();
                  handleForgotPassword(email);
                }}
              >
                Forgot password?
              </a>
            </div>

            <button type="submit" className="my-button" disabled={loading || wsConnecting}>
              {loading || wsConnecting ? (
                <div className="spinner-wrapper">
                  <LoadingSpin />
                </div>
              ) : (
                "Login"
              )}
            </button>

            <div className="register-link">
              <div>
                Don't have an account?{" "}
                <span
                  onClick={newUserLoading}
                  className={`signup-wrapper ${newUserLoadingState ? "loading" : ""}`}
                >
                  <span className="signup-text">Signup</span>
                  {newUserLoadingState && (
                    <div className="spinner-overlay">
                      <LoadingSpin />
                    </div>
                  )}
                </span>
              </div>
            </div>
          </form>
        </div>

        <div className="full-line"></div>

        <div className="terms-conditions">
          <p>
            <a
              href="https://www.algocontroller.com/terms-condition"
              target="_blank"
              rel="noopener noreferrer"
            >
              Terms & Conditions
            </a>
            <span> | </span>
            <a
              href="https://www.algocontroller.com/privacy-policy"
              target="_blank"
              rel="noopener noreferrer"
            >
              Privacy Policy
            </a>
            <span> | </span>
            <a rel="noopener noreferrer">support@algocontroller.com</a>
          </p>
        </div>
      </div>
    </div>
  );
};

export default Login;